import {Container} from "../../components/container/container";
import {Heading} from "../../components/heading/heading";
import {Text} from "../../components/text/text";

export const PrivacyPolicyScreen = () => (
    <Container>
        <Heading>Privacy Policy:</Heading>

        <Text>
            At Blackbot, we take your privacy seriously. This Privacy Policy outlines how we collect, use, and
            protect your personal information when you visit our website or interact with our services.
        </Text>

        <Text>
            Information Collection: We may collect personal information such as your name, email address, and
            contact details when you voluntarily provide them to us through forms or inquiries on our
            website.
        </Text>

        <Text>
            Information Usage: We use the information we collect to provide you with our services, respond to your
            inquiries, improve our website and services, and communicate with you about updates and
            promotions.
        </Text>

        <Text>
            Data Security: We implement security measures to protect your personal information from unauthorized
            access, alteration, disclosure, or destruction.
        </Text>

        <Text>
            Third-Party Disclosure: We do not sell, trade, or otherwise transfer your personal information to third
            parties unless we provide you with advance notice or obtain your consent.
        </Text>

        <Text>
            Cookies: Our website may use cookies to enhance your browsing experience. You can adjust your browser
            settings to disable cookies if you prefer.
        </Text>

        <Text>
            Third-Party Links: Our website may contain links to third-party websites. We are not responsible for the
            privacy practices or content of these websites.
        </Text>

        <Text>
            Updates to Privacy Policy: We may update this Privacy Policy from time to time. Any changes will be
            posted on this page.
        </Text>

        <Text>
            By using our website, you consent to the terms outlined in this Privacy Policy.
        </Text>
    </Container>
);
